import { type FC } from 'react';

import { isTournamentWithStandings } from 'app/config/tournament.config.helper';
import BracketWithStandings from 'app/components/Blocks/BracketsBlock/BracketWithStandings';
import BracketWithSeeds from 'app/components/Blocks/BracketsBlock/BracketWithSeeds';

interface Props {
  bracket: TournamentBracket;
  withTabs?: boolean;
  matchesListCollapsedByDefault?: boolean;
}

const Bracket: FC<Props> = ({ bracket, withTabs, matchesListCollapsedByDefault }) => {
  if (isTournamentWithStandings(bracket)) {
    return (
      <BracketWithStandings
        bracket={bracket}
        withTabs={withTabs}
        matchesListCollapsedByDefault={matchesListCollapsedByDefault}
      />
    );
  }
  return <BracketWithSeeds bracket={bracket} withTabs={withTabs} />;
};

Bracket.displayName = 'Bracket';

export default Bracket;
